/**
 * Ce que le bandeau du prompteur affiche pour les questions de la salle.
 *
 * ⚠️ FICHIER À PART, ET POUR UNE RAISON PRÉCISE : il ne doit RIEN importer.
 * `CompteurSalle.jsx` tire `hooks/useSalle`, donc `axios`, que le Jest de
 * Create React App ne sait pas résoudre — le test de cette fonction, qui la
 * lisait depuis le composant, tombait sur une erreur de module au lieu de
 * tester quoi que ce soit. Pure et isolée, elle se teste sans réseau et sans
 * rendu. Voir `libelleCompteur.test.js`.
 */

/** Le battement du compteur. 15 s : voir CompteurSalle (il tient Render éveillé). */
export const PERIODE_MS = 15000;

export const libelleCompteur = (donnees, etat) => {
    if (!donnees) {
        return {
            texte: etat === 'expire' ? 'reconnexion' : etat === 'panne' ? 'hors ligne' : '…',
            detail: null,
            ton: etat === 'attente' ? 'neutre' : 'alerte',
        };
    }
    const { questions, synthese_sur: syntheseSur } = donnees;
    const apres = syntheseSur != null ? questions - syntheseSur : null;
    return {
        texte: `${questions} question${questions > 1 ? 's' : ''}`,
        // Après la synthèse, seul l'écart compte : ce sont les questions que la
        // voix IA n'a pas vues.
        detail: apres == null ? null : apres > 0 ? `+${apres} après synthèse` : 'synthèse à jour',
        ton: etat === 'ok' ? (apres > 0 ? 'nouveau' : 'ok') : 'perime',
    };
};

/** Les tons du bandeau, en thème clair. */
export const TONS = {
    neutre: 'text-slate-400',
    ok: 'text-slate-700',
    nouveau: 'text-amber-700',
    perime: 'text-slate-400',
    alerte: 'text-amber-700',
};
